import { ContentPage } from '../page-factory/content-page';
import { mauniAmavasyaPage } from '../pages/page-kumbh-2025.mauni-amavasya';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(mauniAmavasyaPage);

export default function MauniAmavasyaPage() {
  return <ContentPage {...mauniAmavasyaPage} />;
}
